import { Field, FieldType, FieldGroup } from "../../../../entities/Metadata";
import { Dictionary, IWithName } from "../../../../entities/common";
import { nameof } from "../../../../store/services/metadataService";
import { TimesheetApprovalDetails } from "../../../../store/TimesheetApprovalStore";
import { TimeReportingPeriod } from "../../../../store/TimeReportingPeriodsStore";
import { FormatDate } from "../../../utils/common";
import { DecisionDateField, DecisionMakersField, ApproverCommentField } from "../../commonFakeFields";

export { ApproverField } from "../../commonFakeFields";
export { DecisionDateField, DecisionMakersField, ApproverCommentField };

export const AdministrativeTimeLabel = "Administrative Time";

export const getTimesheetLineName = (isAdministrative: boolean | undefined, project: { name: string } | null | undefined) =>
    isAdministrative ? AdministrativeTimeLabel : (project?.name ?? "");

export const Title: Field = {
    id: "title",
    name: nameof<IWithName>("Name"),
    type: FieldType.Text,
    isNative: false,
    isSystem: false,
    isCustom: false,
    label: "Title",
    isReadonly: true,
    isFake: true,
    group: FieldGroup.SystemFields,
    settings: {
        views: {
            list: {
                minWidth: 200,
                maxWidth: 300
            }
        }
    }
};

export const PeriodField: Field = {
    id: "period",
    name: nameof<TimesheetApprovalDetails>("period"),
    type: FieldType.Text,
    isNative: false,
    isSystem: false,
    isCustom: false,
    label: "Period",
    isReadonly: true,
    isFake: true,
    group: FieldGroup.SystemFields,
    settings: {
        views: {
            list: {
                minWidth: 130,
                maxWidth: 180
            }
        }
    }
};

export const TotalHoursField: Field = {
    id: "totalHours",
    name: nameof<TimesheetApprovalDetails>("totalHours"),
    type: FieldType.Decimal,
    isNative: false,
    isSystem: false,
    isCustom: false,
    label: "Total Hours",
    isReadonly: true,
    isFake: true,
    group: FieldGroup.SystemFields,
    settings: {
        views: {
            list: {
                minWidth: 80,
                maxWidth: 95
            }
        }
    }
};

export const TimesheetOwnerField: Field = {
    id: "timesheetOwner",
    name: nameof<TimesheetApprovalDetails>("timesheetOwner"),
    type: FieldType.Resource,
    isNative: false,
    isSystem: false,
    isCustom: false,
    label: "Timesheet Owner",
    isReadonly: true,
    isFake: true,
    group: FieldGroup.SystemFields,
    settings: {
        views: {
            list: {
                minWidth: 140,
                maxWidth: 180
            }
        }
    }
};

export const PeriodDatesFilterField: Field = {
    id: "periodFilter",
    name: nameof<TimesheetApprovalDetails>("period"),
    type: FieldType.Date,
    isNative: false,
    isSystem: false,
    isCustom: false,
    label: "Period Dates",
    isReadonly: true,
    isFake: true,
    group: FieldGroup.SystemFields
};

export const PeriodFilterField: Field = {
    id: "periodIds",
    name: "periodIds",
    type: FieldType.Text,
    isNative: false,
    isSystem: false,
    isCustom: false,
    label: "Period",
    isReadonly: true,
    isFake: true,
    group: FieldGroup.SystemFields,
    settings: {
        editControl: "Dropdown",
        options: {}
    }
};

const getPeriodOptions = (periods: TimeReportingPeriod[]) =>
    [...periods]
        .sort((a, b) => b.attributes.StartDate.getTime() - a.attributes.StartDate.getTime())
        .reduce<Dictionary<string>>((acc, _) => {
            acc[_.id] = `${FormatDate(_.attributes.StartDate)} - ${FormatDate(_.attributes.EndDate)}`;
            return acc;
        }, {});

export const buildPeriodFilterField = (periods: TimeReportingPeriod[]): Field => ({
    ...PeriodFilterField,
    settings: {
        ...PeriodFilterField.settings,
        options: getPeriodOptions(periods)
    }
});

export const timesheetFakeFields: Field[] = [
    Title,
    PeriodField,
    PeriodFilterField,
    TotalHoursField,
    TimesheetOwnerField,
    DecisionDateField,
    DecisionMakersField,
    ApproverCommentField
];

export const timesheetFilterableFakeFields: Field[] = [
    Title,
    PeriodDatesFilterField,
    TotalHoursField,
    TimesheetOwnerField,
    DecisionDateField,
    DecisionMakersField,
    ApproverCommentField
];
